import { Collapsable } from 'ia-react-core';
import React, { FC, ReactNode } from 'react';
import { StyledLink, StyledDiv, StyledT4, StyledP } from '../../../DocumentListGroup.styles';
import { StyledCollapseArrow } from './Contracts.styles';
import { Document } from '../../../../../../../interfaces/Document';
import { DocumentGroup } from '../../../../../../../interfaces/DocumentGroup';
import Links from './Links';

export interface ContractsProps {
  document: Document;
  groups: DocumentGroup[];
  children?: ReactNode;
}

const Contracts: FC<ContractsProps> = ({ groups, document }) => {
  if (!document?.visible) return null;
  return (
    <Collapsable name={document.id}>
      <Collapsable.Target>
        {({ toggle, isCollapsed }) => (
          <StyledLink role="button" onClick={toggle} unread={!document.read}>
            <StyledDiv>
              <StyledT4 isRead={document.read}>{document.name}</StyledT4>
              <StyledP>{document.contract.contractName} - {document.contract.contractNumber}</StyledP>
            </StyledDiv>
            <StyledCollapseArrow isCollapsed={isCollapsed} />
          </StyledLink>
        )}
      </Collapsable.Target>
      <Collapsable.Content>
        <Links groups={groups} document={document} />
      </Collapsable.Content>
    </Collapsable>
  );
};

export default Contracts;
